// External dependencies
import $ from 'jquery';

$(window).on('elementor/frontend/init', function () {
	window.elementorFrontend.hooks.addAction(
		'frontend/element_ready/testimonial-global.default',
		function ($scope) {
			const [ element ] = $scope;
			new window.Swiper(element.querySelector('.testimonial-slider-wrapper'), {
				slidesPerView: 3,
				spaceBetween: 5,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				centeredSlides: true,
				centerInsufficientSlides: true,
				freeMode: false,
				loop: true,
				breakpoints: {
					// when window width is >= 280px
					280: {
						slidesPerView: 1,
						spaceBetween: 0,
						centeredSlides: true,

					},
					640: {
						slidesPerView: 1,
						spaceBetween: 0,
						centeredSlides: true,
					},
					768: {
						slidesPerView: 1.9,
						spaceBetween: 0,
						centeredSlides: true,
					},
					1200: {
						slidesPerView: 3,
						spaceBetween: 5,
						centeredSlides: true,
					},
				},
				navigation: {
					nextEl: element.querySelector('.swiper-button-next'),
					prevEl: element.querySelector('.swiper-button-prev'),
				},
			});
		}
	);
});
